import ModelUpdate from "@/models/ModelUpdate";
import {ValidationRule} from "@/declarations/ValidationRule";
import PlanningEntryRules from "@/models/planningEntry/PlanningEntryRules";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";

export default class PlanningEntryUpdate extends ModelUpdate<PlanningEntryListEntry> {

	public orderId!: string | null;
	public date!: string | null;
	public userId!: string | null;
	public notes!: string | null;

	protected initializeWithDetailModelData(detailModel: PlanningEntryListEntry): void {
		this.orderId = detailModel.order.id;
		this.date = detailModel.date;
		this.userId = detailModel.user?.id ?? null;
		this.notes = detailModel.notes;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'orderId':
				return PlanningEntryRules.orderIdRules;
			case 'date':
				return PlanningEntryRules.dateRules;
			default:
				return [];
		}
	}

}
